import { RGB } from './rgb'

/**
 * 指定された色が暗い色か判定する
 *
 * @param {String} code #rrggbb 形式の色コード
 * @returns {Boolean} 暗い色なら true を返す
 */
export function isDark (code) {
  const rgb = RGB.fromCode(code)
  return rgb.luminace() < 0.28
}
